import Vue from 'vue'
import Router from 'vue-router'
import { userKey } from '@/global'

// Container
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

//Checklist
const Checklsit = () => import('@/views/pages/Checklist')

//page Ajuda


const Charts = () => import('@/views/charts/Charts')
const Widgets = () => import('@/views/widgets/Widgets')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

Vue.use(Router)

//export default new Router({
const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: {
        name: 'Login',
      },
    },
    {
      path: '/login',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          name: 'Login',
          path: '',
          component: Login,
        }
      ]
    },
    {
      path: '/',
      component: TheContainer,
      children: [
        {
          path: '',
          redirect: {
            name: 'Dashboard',
          },
        },
        {
          name: 'Dashboard',
          path: 'home',
          component: Dashboard,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'checklist',
          name: 'Checklist',
          component: Checklsit,
          meta: {
            requiresAuth: true
          }
        }
      ]
    }
  ]
}

router.beforeEach ((to, from, next) => {
  const user = JSON.parse(localStorage.getItem(userKey));
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !user) next('/');
  else if (!requiresAuth && user) next('/home');
  else next();
})

export default router;
